import { DecimalPipe } from "@angular/common";
import { Component, Input } from "@angular/core";
import { RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";

import { ComponentnamePipe } from "src/app/pipes";
import { APIResults, AssemblyConfig } from "src/app/sharedinterfaces";

@Component({
	selector: "app-mech-component",
	templateUrl: "./mech-component.component.html",
	styleUrls: ["./mech-component.component.scss"],
	imports: [RouterLink, RouterLinkActive, RouterOutlet, DecimalPipe, ComponentnamePipe]
})
export class MechComponentComponent {
	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	components: APIResults.AssetComponentList;
	@Input()
	component: AssemblyConfig.Component;
	@Input()
	shaft: AssemblyConfig.Shaft;


	private activeRouteComponent: any;
	public updateRouterOutlet(routecomponent?: any) {
		if (routecomponent) {
			this.activeRouteComponent = routecomponent;
		}
		if (this.activeRouteComponent) {
			this.activeRouteComponent.asset = this.asset;
			this.activeRouteComponent.fleet = this.fleet;
			this.activeRouteComponent.components = this.components;
			this.activeRouteComponent.component = this.component;
			this.activeRouteComponent.shaft = this.shaft;
		}
	}
}
